import moment from 'moment';

export const formatCurrency = (value) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(value);
};

export const formatDate = (value, format = 'L') => {
  return moment(value).format(format);
};
